import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Button } from "@mui/material"
import DefaultSignalTableData from './defaultListTable';

interface DefaultSignalDataModalProps {
    signalDataModalOpen: boolean;
    setDefaultSignalDataModalOpen: (open: boolean) => void;
}

const DefaultSignalDataModal: React.FC<DefaultSignalDataModalProps> = (props) => {

    return (
        <Dialog
            open={props.signalDataModalOpen}
            onClose={() => props.setDefaultSignalDataModalOpen(false)}
            PaperProps={{ style: { width: '40%' } }}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Default Signal Data
            </DialogTitle>
            <DialogContent>
                <DefaultSignalTableData setDefaultSignalDataModalOpen={props.setDefaultSignalDataModalOpen}/>
            </DialogContent>
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-evenly"}
                alignItems={"center"}
                padding={'2%'}
            >
                <Button
                    variant='contained'
                    style={{ width: '25%' }}
                    onClick={() => { props.setDefaultSignalDataModalOpen(false); }}
                >
                    CLOSE
                </Button>
            </Box>
        </Dialog>
    );
};

export default DefaultSignalDataModal;
